(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      document.documentElement.classList.add('js-enhanced');
      this.removeAttribute('hidden');

      this._ac = new AbortController();
      const sig = { signal: this._ac.signal };

      this.addEventListener('click', (e) => {
        if (e.target.hasAttribute('data-cart-close') || e.target.closest('[data-cart-close]')) {
          this.close();
        }
      }, sig);

      // Double-register guard: document-delegated handlers must be installed once.
      // A merchant can add a second <cart-drawer> via the schema preset — that second
      // instance would double-fire every ATC submit and qty click without this guard.
      if (window.__cartDrawerBound) return;
      window.__cartDrawerBound = true;
      window.__cartDrawer = this;

      document.addEventListener('submit', (e) => {
        const form = e.target.closest('[data-atc-form]');
        if (!form) return;
        e.preventDefault();
        this._add(form);
      }, sig);

      // Header cart icon opens the drawer (progressive enhancement over the
      // plain /cart link, which stays the no-JS baseline). On the cart page
      // itself the link keeps working — the full page is canonical there.
      document.addEventListener('click', (e) => {
        const cartLink = e.target.closest('.site-header__cart');
        if (!cartLink) return;
        if (document.querySelector('[data-cart-page-section]')) return;
        e.preventDefault();
        this.open(cartLink);
      }, sig);

      document.addEventListener('click', (e) => {
        const dec = e.target.closest('[data-qty-down]');
        const inc = e.target.closest('[data-qty-up]');
        const rem = e.target.closest('[data-cart-remove]');
        if (!dec && !inc && !rem) return;
        if (rem) {
          e.preventDefault();
          const line = e.target.closest('[data-line-key]');
          if (line) this._change(line.dataset.lineKey, 0, e.target);
          return;
        }
        const stepper = e.target.closest('[data-qty-stepper]');
        if (!stepper) return;
        const input = stepper.querySelector('input[type="number"]');
        if (!input) return;
        e.preventDefault();
        // parseInt(...) || 1 would coerce a typed 0 to 1; use NaN check to preserve 0 (= remove).
        const parsed = parseInt(input.value, 10);
        const current = Number.isNaN(parsed) ? 1 : parsed;
        const next = dec ? Math.max(0, current - 1) : current + 1;
        input.value = next;
        const line = e.target.closest('[data-line-key]');
        if (line) this._change(line.dataset.lineKey, next, e.target);
      }, sig);

      // Typed qty in drawer: fire change.js on the input's change event.
      // The drawer has no "Update" button; without this handler typed values are discarded.
      document.addEventListener('change', (e) => {
        const input = e.target.closest('[data-qty-stepper] input[type="number"]');
        if (!input) return;
        const line = input.closest('[data-line-key]');
        if (!line) return;
        const parsed = parseInt(input.value, 10);
        const quantity = Number.isNaN(parsed) || parsed < 0 ? 0 : parsed;
        input.value = quantity;
        this._change(line.dataset.lineKey, quantity, input);
      }, sig);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('cart-drawer--open')) {
          this.close();
        }
      }, sig);
    }

    disconnectedCallback() {
      // Release guard so an editor live-reload re-installs the document listeners.
      if (window.__cartDrawer === this) {
        window.__cartDrawerBound = false;
        window.__cartDrawer = null;
      }
      if (this._ac) this._ac.abort();
    }

    async _add(form) {
      const btn = form.querySelector('[name="add"], button[type="submit"], button:not([name])');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      this._clearError();

      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-bubble');
      fd.append('sections_url', window.location.pathname);

      // Use Shopify.routes.root for locale-prefixed storefronts (/nl/, /de/, etc.).
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = root.replace(/\/$/, '') + '/cart/add.js';

      let data;
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: fd,
          signal: this._ac.signal
        });
        data = await res.json();

        if (!res.ok) {
          const msg = data.description || data.message || this._t('cart.error_generic');
          this._showError(msg);
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
          return;
        }
      } catch (err) {
        if (err.name === 'AbortError') return;
        this._showError(this._t('cart.error_generic'));
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
        return;
      }

      this._swapSections(data.sections);
      this._announce(this._t('cart.added'));

      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }

      this.open(btn);

      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: data }
      }));
    }

    _change(lineKey, quantity, trigger) {
      if (this._changeTimer) clearTimeout(this._changeTimer);
      if (trigger) {
        trigger.disabled = true;
        trigger.setAttribute('aria-busy', 'true');
      }

      this._changeTimer = setTimeout(async () => {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const url = root.replace(/\/$/, '') + '/cart/change.js';

        // On the /cart page, include the cart-page section so optimistic inputs
        // reconcile with the server-clamped quantity and line/subtotal figures refresh.
        const pageHost = document.querySelector('[data-cart-page-section]');
        const pageSectionId = pageHost ? pageHost.getAttribute('data-cart-page-section') : null;
        let sectionList = 'cart-drawer,cart-bubble';
        if (pageSectionId) sectionList += ',' + pageSectionId;

        let data;
        try {
          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: quantity,
              sections: sectionList
            }),
            signal: this._ac.signal
          });
          data = await res.json();
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.warn('[cart-drawer] change failed', err);
          }
          if (trigger) {
            trigger.disabled = false;
            trigger.removeAttribute('aria-busy');
          }
          return;
        }

        if (trigger) {
          trigger.disabled = false;
          trigger.removeAttribute('aria-busy');
        }

        this._swapSections(data.sections);
        this._announce(this._t('cart.updated'));

        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: data }
        }));
      }, 300);
    }

    _swapSections(sections) {
      if (!sections) return;

      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const body = doc.getElementById('CartDrawer');
        const target = document.getElementById('CartDrawer');
        if (body && target) {
          // Safe: Shopify Section Rendering API — same-origin, server-rendered Liquid only.
          target.innerHTML = body.innerHTML;
        }
      }

      const pageHost = document.querySelector('[data-cart-page-section]');
      const pageSectionId = pageHost ? pageHost.getAttribute('data-cart-page-section') : null;
      if (pageSectionId && sections[pageSectionId]) {
        const doc = new DOMParser().parseFromString(sections[pageSectionId], 'text/html');
        const body = doc.getElementById('MainCart');
        const target = document.getElementById('MainCart');
        if (body && target) {
          // Safe: Shopify Section Rendering API — same-origin, server-rendered Liquid only.
          target.innerHTML = body.innerHTML;
        }
      }

      if (sections['cart-bubble']) {
        const doc = new DOMParser().parseFromString(sections['cart-bubble'], 'text/html');
        const host = doc.querySelector('.site-header__cart-count-host');
        const targets = document.querySelectorAll('.site-header__cart-count-host');
        targets.forEach(function(t) {
          if (host) {
            // Safe: Shopify Section Rendering API — same-origin, server-rendered Liquid only.
            t.innerHTML = host.innerHTML;
          }
        });
      }
    }

    open(trigger) {
      this._prevFocus = trigger || document.activeElement;
      this.classList.add('cart-drawer--open');
      const scrim = this.querySelector('.cart-drawer__scrim');
      if (scrim) scrim.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      const closeBtn = this.querySelector('.cart-drawer__close');
      const moveFocus = () => {
        if (closeBtn) closeBtn.focus();
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        moveFocus();
      } else {
        const panel = this.querySelector('.cart-drawer__panel');
        if (panel) {
          panel.addEventListener('transitionend', moveFocus, { once: true, signal: this._ac.signal });
        } else {
          moveFocus();
        }
      }

      // Guard against re-entrant open() installing a second orphaned trap handler.
      if (this._trap) document.removeEventListener('keydown', this._trap);
      this._trap = (e) => {
        if (e.key !== 'Tab') return;
        const focusable = Array.from(
          this.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter(function(el) {
          return !el.closest('[hidden]') && !el.closest('[inert]') && el.offsetParent !== null;
        });
        if (!focusable.length) { e.preventDefault(); return; }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      };
      document.addEventListener('keydown', this._trap, { signal: this._ac.signal });
    }

    close() {
      this.classList.remove('cart-drawer--open');
      const scrim = this.querySelector('.cart-drawer__scrim');
      if (scrim) scrim.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (this._trap) {
        document.removeEventListener('keydown', this._trap);
        this._trap = null;
      }
      if (this._prevFocus && typeof this._prevFocus.focus === 'function') {
        this._prevFocus.focus();
      }
    }

    // _announce writes to #CartDrawerStatus which lives OUTSIDE the swapped
    // #CartDrawer body — ensuring the aria-live announcement survives the innerHTML swap.
    _announce(prefix) {
      const status = this.querySelector('#CartDrawerStatus') || document.getElementById('CartDrawerStatus');
      if (!status) return;
      let msg = prefix || '';
      const subtotalEl = document.querySelector('#CartDrawer .cart-drawer__subtotal-amount');
      const subtotal = subtotalEl ? subtotalEl.textContent.trim() : '';
      const labelEl = document.querySelector('#CartDrawer .cart-drawer__subtotal-label');
      const label = labelEl ? labelEl.textContent.trim() : '';
      if (label && subtotal) {
        msg = msg ? (msg + '. ' + label + ' ' + subtotal) : (label + ' ' + subtotal);
      }
      // Clear first to force re-announce even when text is identical.
      status.textContent = '';
      // eslint-disable-next-line no-unused-expressions
      status.offsetHeight;
      status.textContent = msg;
    }

    _showError(msg) {
      const region = this.querySelector('#CartDrawerError') || document.getElementById('CartDrawerError');
      if (!region) return;
      region.removeAttribute('hidden');
      // textContent — never innerHTML — for error messages (XSS prevention).
      region.textContent = msg;
    }

    _clearError() {
      const region = this.querySelector('#CartDrawerError') || document.getElementById('CartDrawerError');
      if (!region) return;
      region.textContent = '';
      region.setAttribute('hidden', '');
    }

    _t(key) {
      const dataset = {
        'cart.error_generic': this.dataset.i18nError,
        'cart.added': this.dataset.i18nAdded,
        'cart.updated': this.dataset.i18nUpdated
      };
      const fallbacks = {
        'cart.error_generic': "We couldn't add that to your cart. Please try again or reduce the quantity.",
        'cart.added': "Added to cart",
        'cart.updated': "Cart updated"
      };
      return dataset[key] || fallbacks[key] || key;
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo"] && !Shopify.designMode) return;
  try {
    
  class SeoToc extends HTMLElement {
    connectedCallback() {
      var root = this.closest('.col-seo');
      if (!root) return;
      var heads = root.querySelectorAll('.col-seo__h3');
      if (!heads.length) return;
      var n = 0;
      var frag = document.createDocumentFragment();
      heads.forEach(function(h) {
        if (!h.id) return;
        n += 1;
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = n + '. ' + h.textContent;
        frag.appendChild(a);
      });
      if (n > 0) { this.appendChild(frag); this.hidden = false; }
    }
  }
  if (!customElements.get('seo-toc')) customElements.define('seo-toc', SeoToc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this._sectionId = this.dataset.sectionId;
      this._ac = new AbortController();
      var opts = { signal: this._ac.signal };

      /* mobile drawer open/close */
      var openBtn = document.getElementById('open-filters-' + this._sectionId);
      var closeBtn = document.getElementById('close-filters-' + this._sectionId);
      var backdrop = document.getElementById('filters-backdrop-' + this._sectionId);
      var sidebar  = document.getElementById('collection-filters-' + this._sectionId);
      var self     = this;

      if (openBtn && sidebar) {
        openBtn.addEventListener('click', function() { self._openDrawer(); }, opts);
      }
      if (closeBtn && sidebar) {
        closeBtn.addEventListener('click', function() { self._closeDrawer(); }, opts);
      }
      if (backdrop) {
        backdrop.addEventListener('click', function() { self._closeDrawer(); }, opts);
      }
      /* Esc key closes the drawer */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') { self._closeDrawer(); }
      }, opts);

      /* Intercept filter changes + form submit for instant-apply */
      var form = document.getElementById('collection-filter-form-' + this._sectionId);
      if (form) {
        form.addEventListener('change', function(e) {
          if (e.target.type === 'checkbox' || e.target.type === 'number') {
            clearTimeout(self._debounce);
            self._debounce = setTimeout(function() {
              self._fetchSection(new FormData(form));
            }, 350);
          }
        }, opts);

        form.addEventListener('submit', function(e) {
          e.preventDefault();
          self._fetchSection(new FormData(form));
        }, opts);
      }

      /* Sort select lives in the toolbar and is only form-ASSOCIATED via its
         form="" attribute — change events bubble through the DOM (toolbar),
         never through the form element, so it needs its own listener.
         FormData(form) still picks the associated sort_by value up. */
      var sortSelect = document.getElementById('sort-select-' + this._sectionId);
      if (sortSelect) {
        sortSelect.addEventListener('change', function() {
          if (form) {
            self._fetchSection(new FormData(form));
          } else {
            var url = new URL(window.location.href);
            url.searchParams.set('sort_by', sortSelect.value);
            self._fetchUrl(url.toString());
          }
        }, opts);
      }

      /* Grid/list view toggle (progressive enhancement) */
      var viewToggle = document.getElementById('view-toggle-' + this._sectionId);
      var grid = document.getElementById('collection-grid-' + this._sectionId);
      if (viewToggle && grid) {
        viewToggle.addEventListener('click', function(e) {
          var btn = e.target.closest('.collection-view-toggle__btn');
          if (!btn) return;
          var view = btn.dataset.view;
          grid.classList.toggle('collection-grid--list', view === 'list');
          viewToggle.querySelectorAll('.collection-view-toggle__btn').forEach(function(b) {
            var on = b === btn;
            b.classList.toggle('collection-view-toggle__btn--active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        }, opts);
      }

      /* Mark js-enhanced on html element */
      document.documentElement.classList.add('js-enhanced');
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      clearTimeout(this._debounce);
    }

    _openDrawer() {
      /* Capture the trigger element BEFORE moving focus — closeDrawer() restores to it */
      this._prevFocus = document.activeElement;
      var sidebar  = document.getElementById('collection-filters-' + this._sectionId);
      var backdrop = document.getElementById('filters-backdrop-' + this._sectionId);
      var openBtn  = document.getElementById('open-filters-' + this._sectionId);
      if (sidebar) sidebar.classList.add('collection-filters--open');
      if (backdrop) backdrop.classList.add('collection-filters-backdrop--open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      /* Move focus into the drawer */
      if (sidebar) {
        var firstFocusable = sidebar.querySelector('button, a, input, select, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
      }
    }

    _closeDrawer() {
      var sidebar  = document.getElementById('collection-filters-' + this._sectionId);
      var backdrop = document.getElementById('filters-backdrop-' + this._sectionId);
      var openBtn  = document.getElementById('open-filters-' + this._sectionId);
      if (sidebar) sidebar.classList.remove('collection-filters--open');
      if (backdrop) backdrop.classList.remove('collection-filters-backdrop--open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      /* Restore focus */
      if (this._prevFocus) this._prevFocus.focus();
    }

    _fetchSection(formData) {
      var collectionUrl = window.location.pathname;
      var params = new URLSearchParams(formData);
      var url = collectionUrl + '?' + params.toString();
      this._fetchUrl(url);
    }

    _fetchUrl(url) {
      /* Cancel any in-flight request */
      if (this._fetchAc) this._fetchAc.abort();
      this._fetchAc = new AbortController();
      var sectionId = this._sectionId;
      var self = this;

      fetch(url + (url.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + sectionId, {
        signal: this._fetchAc.signal
      })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* Safe: source is Shopify's Section Rendering API (same-origin, server-rendered).
           * URL is always relative to the storefront origin; section_id is a server-generated
           * string — no user-supplied content reaches innerHTML. [mirror related-products.liquid comment] */

          var newGrid = doc.getElementById('collection-grid-' + sectionId);
          var oldGrid = document.getElementById('collection-grid-' + sectionId);
          if (newGrid && oldGrid) oldGrid.innerHTML = newGrid.innerHTML;

          var newCount = doc.getElementById('collection-count-' + sectionId);
          var oldCount = document.getElementById('collection-count-' + sectionId);
          if (newCount && oldCount) oldCount.innerHTML = newCount.innerHTML;

          var newActive = doc.getElementById('active-filters-' + sectionId);
          var oldActive = document.getElementById('active-filters-' + sectionId);
          if (newActive && oldActive) oldActive.innerHTML = newActive.innerHTML;
          else if (!newActive && oldActive) oldActive.innerHTML = '';

          /* Push URL state */
          window.history.pushState({}, '', url);
          /* Close drawer on mobile after applying */
          self._closeDrawer();
        })
        .catch(function(err) {
          if (err.name !== 'AbortError') console.warn('FacetFilters fetch failed', err);
        });
    }
  }
  customElements.define('facet-filters', FacetFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  // Vult het onderwerp-veld vanuit ?onderwerp= (bv. brochure-aanvraag vanaf een productpagina).
  (function () {
    var subject = new URLSearchParams(window.location.search).get('onderwerp');
    if (!subject) return;
    var field = document.getElementById('contact-subject');
    if (field && !field.value) field.value = subject;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeaderController extends HTMLElement {
    connectedCallback() {
      this._hamburger = document.querySelector('.site-header__hamburger');
      this._nav = document.getElementById('site-nav');
      this._closeBtn = document.querySelector('.site-nav__close');
      this._backdrop = document.querySelector('.nav-backdrop');
      this._ac = new AbortController();
      const opts = { signal: this._ac.signal };
      this._hamburger?.addEventListener('click', () => this._openNav(), opts);
      this._closeBtn?.addEventListener('click', () => this._closeNav(), opts);
      this._backdrop?.addEventListener('click', () => this._closeNav(), opts);
      /* WCAG 2.2 SC 1.4.13 / APG dialog: Escape must close the open overlay */
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this._nav?.classList.contains('site-nav--open')) {
          this._closeNav();
        }
      }, opts);
      /* WCAG 2.2 SC 2.1.1: mega-menu keyboard toggle buttons (disclosure pattern) */
      document.querySelectorAll('.site-nav__mega-toggle').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          /* Close all other open menus first */
          document.querySelectorAll('.site-nav__mega-toggle[aria-expanded="true"]').forEach(function(other) {
            if (other !== btn) other.setAttribute('aria-expanded', 'false');
          });
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        }, opts);
        /* Escape closes the open mega-menu and returns focus to toggle */
        btn.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
            btn.setAttribute('aria-expanded', 'false');
            btn.focus();
          }
        }, opts);
      });
    }
    disconnectedCallback() { this._ac.abort(); }
    _openNav() {
      /* Save trigger element BEFORE moving focus so _closeNav() can restore it */
      this._prevFocus = document.activeElement;
      this._nav?.classList.add('site-nav--open');
      this._backdrop?.classList.add('nav-backdrop--open');
      this._hamburger?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstLink = this._nav?.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }
    _closeNav() {
      this._nav?.classList.remove('site-nav--open');
      this._backdrop?.classList.remove('nav-backdrop--open');
      this._hamburger?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (this._prevFocus) this._prevFocus.focus();
    }
  }
  customElements.define('site-header', SiteHeaderController);

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      // Mark JS as available — used by the CSS to toggle combobox vs. plain link
      document.documentElement.classList.add('js-enhanced');

      this._input    = this.querySelector('.predictive-search__input');
      this._wrap     = this.querySelector('.predictive-search__combobox-wrap');
      this._panel    = this.querySelector('.predictive-search__panel');
      this._status   = this.querySelector('.predictive-search__status');
      this._iconLink = this.querySelector('.predictive-search__icon-link');
      this._timer    = null;
      this._ac       = new AbortController();
      var sig = { signal: this._ac.signal };

      // Open input on wrap click (when collapsed)
      this._wrap?.addEventListener('click', function(e) {
        if (!this._input.classList.contains('predictive-search__input--open')) {
          this._openInput();
          e.preventDefault();
        }
      }.bind(this), sig);

      this._input?.addEventListener('focus', function() { this._openInput(); }.bind(this), sig);

      this._input?.addEventListener('input', function() {
        clearTimeout(this._timer);
        this._timer = setTimeout(function() { this._fetch(); }.bind(this), 250);
      }.bind(this), sig);

      this._input?.addEventListener('keydown', function(e) { this._handleKey(e); }.bind(this), sig);

      this._input?.addEventListener('blur', function(e) {
        // Delay close so clicks on results register
        setTimeout(function() {
          if (!this.contains(document.activeElement)) {
            this._closePanel();
          }
        }.bind(this), 150);
      }.bind(this), sig);

      document.addEventListener('click', function(e) {
        if (!this.contains(e.target)) { this._closePanel(); }
      }.bind(this), sig);
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
      this._ac.abort();
      if (this._fetchAc) this._fetchAc.abort();
    }

    _openInput() {
      this._input.classList.add('predictive-search__input--open');
      this._input.focus();
    }

    _fetch() {
      var q = this._input ? this._input.value.trim() : '';
      if (q.length < 2) {
        this._panel.hidden = true;
        this._status.textContent = '';
        return;
      }
      // Cancel any in-flight request
      if (this._fetchAc) this._fetchAc.abort();
      this._fetchAc = new AbortController();

      var url = '/search/suggest?q=' + encodeURIComponent(q) +
                '&section_id=predictive-search' +
                '&resources[type]=product,collection,page,query' +
                '&resources[limit]=6';

      fetch(url, { signal: this._fetchAc.signal })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // Safe: source is Shopify's own /search/suggest endpoint (same-origin, server-rendered).
          // The query `q` is passed through encodeURIComponent; the server renders and escapes all
          // predictive_search.terms / query text via Liquid's | escape filter. No user-supplied
          // content reaches innerHTML un-escaped. Pattern mirrors related-products.liquid:80-82.
          var results = doc.getElementById('predictive-results');
          if (results) {
            this._panel.innerHTML = results.outerHTML;
            this._panel.hidden = false;
            this._wrap?.setAttribute('aria-expanded', 'true');
            var count = this._panel.querySelectorAll('[role="option"]').length;
            this._status.textContent = count + ' resultaten';
          } else {
            this._panel.innerHTML = '';
            this._panel.hidden = true;
            this._wrap?.setAttribute('aria-expanded', 'false');
            this._status.textContent = '0 resultaten';
          }
        }.bind(this))
        .catch(function(err) {
          if (err.name !== 'AbortError') console.warn('PredictiveSearch fetch failed', err);
        });
    }

    _handleKey(e) {
      var options = Array.from(this._panel.querySelectorAll('[role="option"]'));
      var current = options.findIndex(function(o) { return o.getAttribute('aria-selected') === 'true'; });

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = Math.min(current + 1, options.length - 1);
        this._selectOption(options, next);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = Math.max(current - 1, -1);
        if (prev < 0) {
          this._clearSelection(options);
          this._input.setAttribute('aria-activedescendant', '');
        } else {
          this._selectOption(options, prev);
        }
      } else if (e.key === 'Enter') {
        var active = options[current];
        if (active) {
          e.preventDefault();
          window.location.href = active.href;
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        this._closePanel();
        this._input.focus();
      } else if (e.key === 'Tab') {
        this._closePanel();
      }
    }

    _selectOption(options, idx) {
      this._clearSelection(options);
      if (idx >= 0 && options[idx]) {
        options[idx].setAttribute('aria-selected', 'true');
        this._input.setAttribute('aria-activedescendant', options[idx].id || '');
        options[idx].scrollIntoView({ block: 'nearest' });
      }
    }

    _clearSelection(options) {
      options.forEach(function(o) { o.setAttribute('aria-selected', 'false'); });
    }

    _closePanel() {
      this._panel.hidden = true;
      this._panel.innerHTML = '';
      this._wrap?.setAttribute('aria-expanded', 'false');
      this._input?.classList.remove('predictive-search__input--open');
      this._input?.setAttribute('aria-activedescendant', '');
      this._status.textContent = '';
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  class FinderForm extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const form = this.querySelector('form');
      if (!form) return;
      // Convert the budget machine value ("750-1500", "-750", "3000-") into the
      // native storefront price filter params Shopify applies server-side.
      // Q1 values that start with "/" are collection URLs — navigate there and
      // apply the budget as a native price filter. Anything else falls back to
      // a plain product search with q.
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        const q = (fd.get('q') || '').toString().trim();
        let url;
        if (q.startsWith('/')) {
          url = new URL(q, window.location.origin);
        } else {
          url = new URL(form.getAttribute('action'), window.location.origin);
          if (q && q !== '*') url.searchParams.set('q', q);
          url.searchParams.set('type', 'product');
        }
        const budget = (fd.get('budget') || '').toString();
        if (budget) {
          const parts = budget.split('-');
          if (parts[0]) url.searchParams.set('filter.v.price.gte', parts[0]);
          if (parts[1]) url.searchParams.set('filter.v.price.lte', parts[1]);
        }
        window.location.assign(url.toString());
      }, { signal: this._ac.signal });
    }
    disconnectedCallback() { this._ac.abort(); }
  }
  customElements.define('finder-form', FinderForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  /* ── PdpVariantPicker Web Component ── */
  class PdpVariantPicker extends HTMLElement {
    connectedCallback() {
      document.documentElement.classList.add('js-enhanced');

      this._ac = new AbortController();
      const sig = { signal: this._ac.signal };

      const sectionId = this.dataset.section;
      this._sectionId = sectionId;
      const variantsEl = document.getElementById('product-json-' + sectionId);
      if (!variantsEl) return;

      this._variants = JSON.parse(variantsEl.textContent);
      this._hiddenInput = document.getElementById('pdp-variant-id-' + sectionId);
      this._priceNow = document.getElementById('pdp-price-now-' + sectionId);
      this._priceWas = document.getElementById('pdp-price-was-' + sectionId);
      this._savePill = document.getElementById('pdp-save-pill-' + sectionId);
      this._atcBtn = document.getElementById('pdp-atc-' + sectionId);

      // Low-stock scarcity line: per-variant tracked stock map (null = untracked)
      this._stockEl = document.getElementById('pdp-stock-' + sectionId);
      const stockJson = document.getElementById('pdp-stock-json-' + sectionId);
      this._stockMap = stockJson ? JSON.parse(stockJson.textContent) : null;

      this._selectedOptions = [];

      // Read initial option values from native selects
      const selects = document.querySelectorAll('[data-option-index]');
      selects.forEach((sel) => {
        if (sel.tagName === 'SELECT') {
          this._selectedOptions[parseInt(sel.dataset.optionIndex)] = sel.value;
        }
      });

      // Wire tile clicks (size tiles + finish swatch tiles)
      this.querySelectorAll('.pdp-buy-panel__size-tile, .pdp-buy-panel__finish-tile').forEach((tile) => {
        tile.addEventListener('click', () => {
          if (tile.getAttribute('aria-disabled') === 'true') return;
          const optionIndex = parseInt(tile.dataset.optionIndex);
          const value = tile.dataset.value;
          this._selectedOptions[optionIndex] = value;

          // Update active class within this option group
          const group = tile.closest('.pdp-buy-panel__size-grid, .pdp-buy-panel__finish-grid');
          group.querySelectorAll('.pdp-buy-panel__size-tile, .pdp-buy-panel__finish-tile').forEach((t) => {
            const isActive = t.dataset.value === value;
            t.classList.toggle('active', isActive);
            t.setAttribute('aria-pressed', isActive.toString());
          });

          // Sync native select
          const nativeSelect = document.querySelector(
            '[data-option-index="' + optionIndex + '"].pdp-buy-panel__select-native'
          );
          if (nativeSelect) {
            nativeSelect.value = value;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // Sync the "chosen: X" label in the option head
          const valueDisplay = this.querySelector(
            '[data-option-value-display="' + optionIndex + '"]'
          );
          if (valueDisplay) valueDisplay.textContent = value;

          // Find matching variant
          this._updateVariant();
        }, sig);
      });
    }

    _findVariant() {
      return this._variants.find((v) => {
        return v.options.every((opt, i) => opt === this._selectedOptions[i]);
      });
    }

    _updateVariant() {
      const variant = this._findVariant();
      if (!variant) return;

      // Update hidden id input
      if (this._hiddenInput) this._hiddenInput.value = variant.id;

      // Format money (cents to display)
      const fmt = (cents) => {
        const amount = (cents / 100).toFixed(2).replace('.', ',');
        return '€ ' + amount;
      };

      // Update price now
      if (this._priceNow) this._priceNow.textContent = fmt(variant.price);

      // Update compare-at + save pill
      if (this._priceWas && this._savePill) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this._priceWas.textContent = fmt(variant.compare_at_price);
          this._priceWas.classList.remove('pdp-buy-panel__price-was--hidden');
          this._priceWas.removeAttribute('aria-hidden');

          const saveLabel = this._savePill.getAttribute('data-save-label') || '';
          this._savePill.textContent = (saveLabel ? saveLabel + ' ' : '') + fmt(variant.compare_at_price - variant.price);
          this._savePill.classList.remove('pdp-buy-panel__save-pill--hidden');
          this._savePill.removeAttribute('aria-hidden');
        } else {
          this._priceWas.textContent = '';
          this._priceWas.classList.add('pdp-buy-panel__price-was--hidden');
          this._priceWas.setAttribute('aria-hidden', 'true');
          this._savePill.textContent = '';
          this._savePill.classList.add('pdp-buy-panel__save-pill--hidden');
          this._savePill.setAttribute('aria-hidden', 'true');
        }
      }

      // Update ATC button availability
      if (this._atcBtn) {
        if (variant.available) {
          this._atcBtn.removeAttribute('disabled');
          this._atcBtn.removeAttribute('aria-disabled');
          const label = this._atcBtn.querySelector('.pdp-buy-panel__atc-label');
          const price = this._atcBtn.querySelector('.pdp-buy-panel__atc-price');
          if (label) label.textContent = this._atcBtn.dataset.addLabel || label.textContent;
          if (price) {
            price.textContent = fmt(variant.price);
            price.style.display = '';
          }
        } else {
          this._atcBtn.setAttribute('disabled', '');
          this._atcBtn.setAttribute('aria-disabled', 'true');
          const label = this._atcBtn.querySelector('.pdp-buy-panel__atc-label');
          const price = this._atcBtn.querySelector('.pdp-buy-panel__atc-price');
          if (label) label.textContent = this._atcBtn.dataset.ooLabel || label.textContent;
          if (price) price.style.display = 'none';
        }
      }

      // Low-stock scarcity line: show only for tracked stock within the threshold
      if (this._stockEl && this._stockMap) {
        const qty = this._stockMap[String(variant.id)];
        const threshold = parseInt(this._stockEl.dataset.threshold, 10) || 0;
        if (typeof qty === 'number' && qty > 0 && qty <= threshold) {
          const template = this._stockEl.dataset.template || '';
          this._stockEl.textContent = template.replace('%%COUNT%%', qty);
          this._stockEl.hidden = false;
        } else {
          this._stockEl.textContent = '';
          this._stockEl.hidden = true;
        }
      }

      // Broadcast the new variant so the sticky ATC bar can sync
      this.dispatchEvent(
        new CustomEvent('pdp:variant-change', {
          bubbles: true,
          detail: {
            sectionId: this._sectionId,
            price: variant.price,
            compareAtPrice: variant.compare_at_price,
            available: variant.available,
            title: variant.title,
          },
        })
      );
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
    }
  }

  customElements.define('pdp-variant-picker', PdpVariantPicker);

  /* ── PdpQtyStepper Web Component ── */
  class PdpQtyStepper extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const sig = { signal: this._ac.signal };

      this._input = this.querySelector('input[type="number"]');
      const minus = this.querySelector('.pdp-buy-panel__qty-minus');
      const plus = this.querySelector('.pdp-buy-panel__qty-plus');

      if (minus) {
        minus.addEventListener('click', () => {
          const current = parseInt(this._input.value) || 1;
          const next = Math.max(1, current - 1);
          this._input.value = next;
          minus.disabled = next <= 1;
        }, sig);
      }

      if (plus) {
        plus.addEventListener('click', () => {
          const current = parseInt(this._input.value) || 1;
          this._input.value = current + 1;
          if (minus) minus.disabled = false;
        }, sig);
      }

      // Init minus disabled state
      if (minus && parseInt(this._input.value) <= 1) {
        minus.disabled = true;
      }
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
    }
  }

  customElements.define('pdp-qty-stepper', PdpQtyStepper);

  /* ── PdpGallery Web Component — single-stage viewer + dialog lightbox.
     No-JS baseline: stacked frames with anchor-jump thumbs (chrome ships hidden). ── */
  class PdpGallery extends HTMLElement {
    connectedCallback() {
      document.documentElement.classList.add('js-enhanced');

      this._ac = new AbortController();
      const sig = { signal: this._ac.signal };

      this._thumbs = Array.from(this.querySelectorAll('.pdp-gallery__thumb'));
      this._frames = Array.from(this.querySelectorAll('.pdp-gallery__frame'));
      this._counter = this.querySelector('[data-gallery-counter]');
      this._lightbox = this.querySelector('[data-gallery-lightbox]');
      this._lbImg = this.querySelector('[data-lightbox-img]');
      this._lbCounter = this.querySelector('[data-lightbox-counter]');
      this._index = 0;

      if (!this._frames.length) return;

      // Reveal viewer chrome (no-JS gate)
      const zoomBtn = this.querySelector('[data-gallery-zoom]');
      const prevBtn = this.querySelector('[data-gallery-prev]');
      const nextBtn = this.querySelector('[data-gallery-next]');
      if (zoomBtn) zoomBtn.hidden = false;
      if (this._frames.length > 1) {
        if (prevBtn) prevBtn.hidden = false;
        if (nextBtn) nextBtn.hidden = false;
        if (this._counter) this._counter.hidden = false;
      } else {
        // Single image: hide the lightbox arrows too
        this.querySelectorAll('[data-lightbox-prev], [data-lightbox-next]').forEach((b) => { b.hidden = true; });
      }

      this._show(0);

      this._thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          this._show(i);
        }, sig);
      });

      this._setupThumbsSlider(sig);

      prevBtn?.addEventListener('click', () => this._show(this._index - 1), sig);
      nextBtn?.addEventListener('click', () => this._show(this._index + 1), sig);

      // Arrow keys navigate the stage (lightbox handles its own keys while open)
      this.addEventListener('keydown', (e) => {
        if (this._lightbox && this._lightbox.open) return;
        if (e.key === 'ArrowLeft') this._show(this._index - 1);
        if (e.key === 'ArrowRight') this._show(this._index + 1);
      }, sig);

      // Zoom: click the stage image or the zoom button
      this.querySelectorAll('.pdp-gallery__zoom-link').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this._openLightbox();
        }, sig);
      });
      zoomBtn?.addEventListener('click', () => this._openLightbox(), sig);

      // Lightbox controls (Esc + focus containment are native to showModal)
      this.querySelector('[data-lightbox-close]')?.addEventListener('click', () => this._lightbox.close(), sig);
      this.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => { this._show(this._index - 1); this._syncLightbox(); }, sig);
      this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => { this._show(this._index + 1); this._syncLightbox(); }, sig);
      this._lightbox?.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this._show(this._index - 1); this._syncLightbox(); }
        if (e.key === 'ArrowRight') { this._show(this._index + 1); this._syncLightbox(); }
      }, sig);
      // Backdrop click closes — a click on the dialog element itself is outside the content
      this._lightbox?.addEventListener('click', (e) => {
        if (e.target === this._lightbox) this._lightbox.close();
      }, sig);
    }

    _show(i) {
      const n = this._frames.length;
      this._index = ((i % n) + n) % n;
      this._frames.forEach((frame, k) => {
        frame.classList.toggle('pdp-gallery__frame--active', k === this._index);
      });
      this._thumbs.forEach((thumb, k) => {
        const isActive = k === this._index;
        thumb.classList.toggle('active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (this._counter) this._counter.textContent = (this._index + 1) + ' / ' + n;
    }

    _openLightbox() {
      if (!this._lightbox || !this._lbImg) return;
      this._syncLightbox();
      this._lightbox.showModal();
    }

    _syncLightbox() {
      const frame = this._frames[this._index];
      if (!frame) return;
      const link = frame.querySelector('.pdp-gallery__zoom-link');
      const img = frame.querySelector('.pdp-gallery__frame-img');
      if (link) this._lbImg.src = link.getAttribute('href');
      this._lbImg.alt = img ? img.alt || '' : '';
      if (this._lbCounter) this._lbCounter.textContent = (this._index + 1) + ' / ' + this._frames.length;
    }

    /* Reveals the prev/next arrows only when the capped thumbs list actually overflows
       (desktop: block-axis cap; mobile: the arrows are hidden by CSS and this becomes a
       no-op check on an axis that never overflows). Works for whichever axis is capped
       without branching on breakpoint. */
    _setupThumbsSlider(sig) {
      const list = this.querySelector('[data-thumbs-list]');
      const prev = this.querySelector('[data-thumbs-prev]');
      const next = this.querySelector('[data-thumbs-next]');
      if (!list || !prev || !next) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const sync = () => {
        const overflows = list.scrollHeight > list.clientHeight + 1 || list.scrollWidth > list.clientWidth + 1;
        prev.hidden = !overflows;
        next.hidden = !overflows;
        if (!overflows) return;
        prev.disabled = list.scrollTop <= 0 && list.scrollLeft <= 0;
        const atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 1
          && list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
        next.disabled = atEnd;
      };

      const page = (dir) => {
        list.scrollBy({
          top: dir * list.clientHeight,
          left: dir * list.clientWidth,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      };

      prev.addEventListener('click', () => page(-1), sig);
      next.addEventListener('click', () => page(1), sig);
      list.addEventListener('scroll', sync, { ...sig, passive: true });
      window.addEventListener('resize', sync, { ...sig, passive: true });

      sync();
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
    }
  }

  customElements.define('pdp-gallery', PdpGallery);

  /* ── PdpStickyAtc Web Component ── */
  class PdpStickyAtc extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const sig = { signal: this._ac.signal };

      const sectionId = this.dataset.section;
      this._mainAtc = document.getElementById('pdp-atc-' + sectionId);
      this._stickyBtn = document.getElementById('pdp-sticky-atc-btn-' + sectionId);
      this._priceNow = document.getElementById('pdp-sticky-price-now-' + sectionId);
      this._priceWas = document.getElementById('pdp-sticky-price-was-' + sectionId);
      this._btnPrice = document.getElementById('pdp-sticky-btn-price-' + sectionId);
      this._variantEl = document.getElementById('pdp-sticky-variant-' + sectionId);

      if (!this._mainAtc) return;

      // Reveal the sticky bar whenever the main ATC is out of view. The old top offset
      // in rootMargin was there to clear the header while the bar was pinned to the top;
      // now that it sits at the bottom, plain viewport intersection is what we want.
      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.hidden = entry.isIntersecting;
          });
        },
        { rootMargin: '0px' }
      );
      this._io.observe(this._mainAtc);

      // Sticky button submits the main product form via the real ATC.
      if (this._stickyBtn) {
        this._stickyBtn.addEventListener('click', () => {
          if (this._stickyBtn.hasAttribute('disabled')) return;
          this._mainAtc.click();
        }, sig);
      }

      // Keep the sticky bar in sync with variant changes.
      document.addEventListener('pdp:variant-change', (e) => {
        if (!e.detail || e.detail.sectionId !== sectionId) return;
        this._sync(e.detail);
      }, sig);
    }

    _sync(d) {
      const fmt = (cents) => '€ ' + (cents / 100).toFixed(2).replace('.', ',');

      if (this._priceNow) this._priceNow.textContent = fmt(d.price);
      if (this._btnPrice) this._btnPrice.textContent = fmt(d.price);
      if (this._variantEl && d.title) this._variantEl.textContent = d.title;

      if (this._priceWas) {
        if (d.compareAtPrice && d.compareAtPrice > d.price) {
          this._priceWas.textContent = fmt(d.compareAtPrice);
          this._priceWas.classList.remove('pdp-sticky-atc__price-was--hidden');
          this._priceWas.removeAttribute('aria-hidden');
        } else {
          this._priceWas.textContent = '';
          this._priceWas.classList.add('pdp-sticky-atc__price-was--hidden');
          this._priceWas.setAttribute('aria-hidden', 'true');
        }
      }

      if (this._stickyBtn) {
        const label = this._stickyBtn.querySelector('.pdp-sticky-atc__button-label');
        if (d.available) {
          this._stickyBtn.removeAttribute('disabled');
          this._stickyBtn.removeAttribute('aria-disabled');
          if (label) label.textContent = this._stickyBtn.dataset.addLabel || label.textContent;
          if (this._btnPrice) this._btnPrice.style.display = '';
        } else {
          this._stickyBtn.setAttribute('disabled', '');
          this._stickyBtn.setAttribute('aria-disabled', 'true');
          if (label) label.textContent = this._stickyBtn.dataset.ooLabel || label.textContent;
          if (this._btnPrice) this._btnPrice.style.display = 'none';
        }
      }
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      if (this._io) this._io.disconnect();
    }
  }

  customElements.define('pdp-sticky-atc', PdpStickyAtc);

  /* ── PdpAddons Web Component — toggle add-on cards (visual selection) ── */
  class PdpAddons extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      this.querySelectorAll('.pdp-addon').forEach((card) => {
        card.addEventListener('click', () => {
          const next = card.getAttribute('aria-pressed') !== 'true';
          card.setAttribute('aria-pressed', next ? 'true' : 'false');
        }, { signal: this._ac.signal });
      });
    }
    disconnectedCallback() {
      if (this._ac) this._ac.abort();
    }
  }
  customElements.define('pdp-addons', PdpAddons);

  /* ── PdpDelivery Web Component — postcode check reveals the confirmation row ── */
  class PdpDelivery extends HTMLElement {
    connectedCallback() {
      this._ac = new AbortController();
      const btn = this.querySelector('.pdp-delivery-box__zip-btn');
      const input = this.querySelector('.pdp-delivery-box__zip-input');
      const ok = this.querySelector('.pdp-delivery-box__row--ok');
      if (!btn || !ok) return;
      const reveal = () => {
        if (input && input.value.trim() === '') { input.focus(); return; }
        ok.hidden = false;
      };
      btn.addEventListener('click', reveal, { signal: this._ac.signal });
      if (input) {
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') { e.preventDefault(); reveal(); }
        }, { signal: this._ac.signal });
      }
    }
    disconnectedCallback() {
      if (this._ac) this._ac.abort();
    }
  }
  customElements.define('pdp-delivery', PdpDelivery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      this._ac = new AbortController();
      fetch(url, { signal: this._ac.signal })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.getElementById('related-products-grid');
          if (grid && grid.innerHTML.trim()) {
            // Safe: source is Shopify's Section Rendering API (same-origin, server-rendered).
            // routes.product_recommendations_url is a Shopify-owned endpoint; section_id and
            // product_id are server-generated integers — no user-supplied content reaches innerHTML.
            this.innerHTML = grid.innerHTML;
          }
        }.bind(this))
        .catch(function(err) {
          if (err.name !== 'AbortError') console.warn('ProductRecommendations fetch failed', err);
        });
    }
    disconnectedCallback() {
      if (this._ac) this._ac.abort();
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  class SearchCriteria extends HTMLElement {
    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      const fmt = (n) => '€ ' + Number(n).toLocaleString('nl-NL');
      const items = [];
      if (params.get('width')) items.push(this.dataset.lWidth + ': ' + params.get('width'));
      if (params.get('depth')) items.push(this.dataset.lDepth + ': ' + params.get('depth'));
      const gte = params.get('filter.v.price.gte');
      const lte = params.get('filter.v.price.lte');
      if (gte || lte) {
        let budget;
        if (gte && lte) budget = fmt(gte) + ' – ' + fmt(lte);
        else if (lte) budget = 'tot ' + fmt(lte);
        else budget = fmt(gte) + ' +';
        items.push(this.dataset.lBudget + ': ' + budget);
      }
      if (!items.length) return;

      // All values come from the URL — build via textContent only, never innerHTML.
      const label = document.createElement('span');
      label.className = 'search__criteria-label';
      label.textContent = this.dataset.lLabel;
      this.appendChild(label);
      items.forEach((text) => {
        const chip = document.createElement('span');
        chip.className = 'chip';
        chip.textContent = text;
        this.appendChild(chip);
      });
      const clear = document.createElement('a');
      const url = new URL(window.location.href);
      ['width', 'depth', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((k) => url.searchParams.delete(k));
      clear.href = url.toString();
      clear.className = 'search__criteria-clear';
      clear.textContent = this.dataset.lClear;
      this.appendChild(clear);
      this.hidden = false;
    }
  }
  customElements.define('search-criteria', SearchCriteria);

  } catch(e) { console.error(e); }
})();
})();
